module.exports = __webpack_public_path__ + "media/images/subject_img/ENGLISH LITERATURE-d87f5c995beaff5c5f244cb9b1f864b4.jpg";